// extracted by mini-css-extract-plugin
export var avatarContainer = "_8x-0";
export var avatarTypingWave = "_8x-i";
export var gray = "_8x-f";
export var green = "_8x-c";
export var icon = "_8x-9";
export var image = "_8x-1";
export var lg = "_8x-6";
export var md = "_8x-5";
export var presenceDot = "_8x-b";
export var red = "_8x-d";
export var sm = "_8x-4";
export var status = "_8x-a";
export var typingDot = "_8x-h";
export var typingPill = "_8x-g";
export var xl = "_8x-7";
export var xs = "_8x-3";
export var xxl = "_8x-8";
export var xxs = "_8x-2";
export var yellow = "_8x-e";